<template>
	<div class='common-right-wrap'>
		<div class="search-wrap">
			<div class="search-title">文章搜索</div>
			<el-input v-model="article" placeholder="请输入文章标题、内容的关键词">
				<el-button slot="append" icon="el-icon-search" @click="creditSearchHandler"></el-button>
			</el-input>
		</div>
		<div class="look-wrap wrap-border">
			<div class="border-5">
				<div class="active">
					<i class="iconfont icon-sort-full"></i>
					快速链接
				</div>
			</div>
			<div class="">
				<div class="link-title flex">
					<i class="iconfont icon-rizhi"></i>肥城社会诚信体系主体信息查询
				</div>
				<el-input class="server-search" v-model="search" :placeholder="placeholder">
					<el-select v-model="select" slot="prepend" placeholder="请选择">
						<el-option label="信用信息" :value="1"></el-option>
						<el-option label="统一社会信用代码" :value="2"></el-option>
					</el-select>
					<el-button slot="append" icon="el-icon-search" @click="searchHandler"></el-button>
				</el-input>
				<div class="flex flex-wrap flex-row-between link-wrap">
					<router-link class="flex flex-row-center wrap-border" v-for="(item, index) in rightLinkList" :key="index" :to="item.href">
						<img :src="item.image" alt="" srcset="" v-if="!isArticle">
						<p>{{item.title}}</p>
					</router-link>
				</div>
			</div>
		</div>
		<div class="look-wrap wrap-border" v-if="recommend.length>0">
			<div class="border-5">
				<div class="active">
					<i class="el-icon-tickets"></i>大家都在看
				</div>
			</div>
			<div class="recommend-wrap" v-if="recommend.length>0">
				<div v-for="(item, index) in recommend" :key="item.id" class="flex" @click="goPath(item)">
					<p>{{item.title}}</p>
					<img v-if="index===0" src="@/static/images/server/hot.png" alt="">
					<img v-if="index===1" src="@/static/images/server/yellowHot.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { NAVLIST } from '@/utils/viewIndex';

export default {
	components: {},
	data() {
		return {
			article: undefined,
			search: undefined,
			select: 1,
			rightLinkList: [],
		}
	},
	props: {
		recommend: {
			type: Array,
			default: []
		},
		routerZhName: {
			type: String,
			default: ''
		},
		isArticle: {
			type: Boolean,
			default: false
		}
	},
	created() { },
	mounted() { },
	methods: {
		searchHandler() {
			if (this.search) {
				this.$router.push({
					name: 'searchCompanyList',
					query: {
						type: this.select, keywords: this.search
					}
				})
			}
		},
		creditSearchHandler() {
			if (this.article) {
				this.$router.push({
					name: 'searchArticle',
					query: {
						keywords: this.article
					}
				})
			}
		},
		formatType(row) {
			const name = this.routerZhName ? this.routerZhName : this.$route.meta.title;
			// 1信用动态，2行业信用，3诚信宣传，4政策法规，5信用研究，6专项治理,7风险提示,8联合奖惩,9通知公告
			switch (name) {
				case '信用动态':
					return 1;
				case '行业信用':
					return 2;
				case '诚信宣传':
					return 3;
				case '政策法规':
					return 4;
				case '信用研究':
					return 5;
				case '专项治理,':
					return 6;
				case '风险提示':
					return 7;
				case '联合奖惩':
					return 8;
				case '通知公告':
					return 9;
				default:
					break;
			}
		},
		goPath(row) {
			const type = this.formatType(row);
			this.$router.push({ path: `/common/article/${type}/${row.id}` })
		}
	},
	computed: {
		routerList() {
			return NAVLIST;
		},
		placeholder() {
			if (this.select === 2) {
				return '请输入主体名称或统一社会信用代码'
			} else {
				return '请输入主体名称'
			}
		}
	},
	watch: {
		routerZhName: {
			handler(val, oldval) {
				const list = this.routerList;
				if (this.isArticle) {
					// 行业信用 暂无详情 看不到
					if (['信用动态', '政策法规', '风险提示', '诚信宣传', '信用研究', '专项治理'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[1], list[3], list[7], {
							id: 10,
							title: '信用应用',
							href: '/industries',
							link: '/industries',
						},])
					}
				} else {
					if (['信用动态', '风险提示', '通知公告'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[4], list[10], list[9], list[6]])
					}
					if (['政策法规', '信用研究'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[1], list[10], list[9], list[6]])
					}
					if (['诚信宣传'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[10], list[3], list[2], list[6]])
					}
					if (['专项治理'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[4], list[10], list[4], list[6]])
					}
					if (['行业信用', '行政许可', '行政处罚'].includes(val)) {
						this.$set(this, 'rightLinkList', [list[1], list[3], list[7], list[2]])
					}
				}

			},
			deep: true
		},
	},
}
</script>
<style lang='scss'>
	$red: #d01c0b;
	.common-right-wrap {
		width: 100%;
		.search-wrap {
			background-color: #e0e7ed;
			padding: 15px;
			.search-title {
				font-weight: 600;
				text-align: left;
				font-size: 18px;
			}

			.el-input {
				width: 370px;
				margin: 20px auto 10px;
				height: 40px;
				.el-input__inner {
					border-color: #ccc;
					height: 40px;
					line-height: 40px;
					border-right: none;
				}
				.el-input-group__append {
					border-color: #ccc;
					height: 40px;
					background-color: #fff;
					border-left: none;
					.el-icon-search {
						color: #d8e1e9;
					}
				}
			}
		}

		.look-wrap {
			padding: 20px;
			margin-top: 20px;
            text-align: center;

			.active {
				width: 35%;
				padding: 0 10px 5px;
				text-align: left;
				i {
					font-size: 28px;
					font-weight: bold;
					color: $red;
					margin-right: 4px;
				}
			}

			.link-title {
				text-align: left;
				margin: 18px 0;
				i {
					font-size: 25px;
					font-weight: bold;
					color: $red;
					margin-right: 4px;
				}
			}
			.server-search {
				width: 100%;
				margin-bottom: 15px;
				height: 40px;
				.el-input-group__prepend {
					padding: 0 0 0 5px;
					width: 25%;
					flex-shrink: 0;
					border: 1px solid $red;
					border-right: none;
					background-color: #fff;
					font-size: 14px;
					.el-select {
						width: 100%;
						.el-input {
							width: 100%;
							.el-input__inner {
								padding: 0;
								font-size: 13px;
							}
						}
					}
				}
				.el-input__inner {
					font-size: 14px;
				}
			}
			.link-wrap {
				.flex {
					flex-basis: 49%;
					margin: 10px 0;
					padding: 15px 0;
					& > img {
						& + p {
							margin-left: 20px;
						}
					}
				}
			}

			& > .recommend-wrap {
				overflow-x: hidden;
				overflow-y: auto;
				& > .flex {
					position: relative;
					margin-top: 15px;
					padding-left: 20px;
					cursor: pointer;
					&:first-of-type {
						color: $red;
					}
					&:nth-child(2) {
						color: #ffa13e;
					}
					&::before {
						content: '';
						width: 8px;
						height: 8px;
						border-radius: 50%;
						background: $red;
						position: absolute;
						top: 7px;
						left: 0;
					}

					& > p {
						text-align: left;
					}
					& > img {
						margin-left: 10px;
					}
				}
			}
		}
	}
</style>
